import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import TableIdButton from "@lib/components/MiniComponents/Buttons/TableIdButton";
import { shortenString } from "@lib/helpers/StringHelper";
import { ColumnConfig, generateColumns } from "@lib/helpers/TableHelper";
import { MarketPlaceSummary } from "@lib/types/MarketPlace";
import { TableColumnsProps } from "@lib/types/General";
import { IntlShape } from "react-intl";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";

type Props<T> = TableColumnsProps<T> & {
  handleSelectItem: (item: T) => void;
  messages: IntlShape["messages"];
};

const getColumns = <T extends MarketPlaceSummary>(
  props: Props<T>,
): ColumnsType<T> => {
  const { handleSelectItem } = props;

  const columnsConfig: ColumnConfig<T>[] = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      render: (v, r) => (
        <TableIdButton text={`#${shortenString(r.id)}`} textToBeCopied={r.id} />
      ),
      width: "180px",
      filterType: "search",
    },
    {
      title: "common.summary",
      dataIndex: "summary",
      key: "summary",
      fixed: "left",
      width: "400px",
      render: (text) => (
        <div
          style={{
            maxWidth: "400px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {text}
        </div>
      ),
      filterType: "search",
    },
    {
      title: "common.opportunities",
      dataIndex: "opportunities",
      key: "opportunities",
      width: "300px",
      render: (opportunities: string[]) => {
        if (!opportunities || opportunities.length === 0) return "-";
        return (
          <div
            style={{
              maxWidth: "300px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {opportunities.join(", ")}
          </div>
        );
      },
    },
    {
      title: "common.createdAt",
      dataIndex: "createdAt",
      key: "createdAt",
      width: "150px",
      render: (d) => (d ? dayjs(d).format("DD/MM/YYYY HH:mm") : "-"),
    },
    {
      title: "common.createdBy",
      dataIndex: "createdBy",
      key: "createdBy",
      width: "150px",
      filterType: "dropdown",
    },
    {
      title: "common.updatedAt",
      dataIndex: "updatedAt",
      width: "150px",
      render: (d) => (d ? dayjs(d).format("DD/MM/YYYY HH:mm") : "-"),
    },
    {
      title: "common.updatedBy",
      dataIndex: "updatedBy",
      width: "160px",
      filterType: "dropdown",
    },
    {
      title: "common.actions",
      dataIndex: "actions",
      key: "actions",
      className: "order-table-action",
      fixed: "right",
      width: "110px",
      render: (_, record) => (
        <StyledFlex className="actions">
          <ActionButton
            type="quickLook"
            onClick={() => handleSelectItem(record)}
            noLabel
          />
        </StyledFlex>
      ),
    },
  ];

  return generateColumns(props, columnsConfig);
};

export default getColumns;
